// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tool-button{z-index:99;width:100%;position:relative}.tool-button .look-before-switch{display:flex;gap:5px;height:32px}.tool-button .look-before-switch .date-picker-wrapper{position:relative}.tool-button .look-before-switch .date-picker-wrapper .paper-date-wrapper,.tool-button .look-before-switch img{width:32px}.tool-button .pc-paper-date{position:relative}", ""]);
// Exports
module.exports = exports;
